<script setup>
import { ref, reactive, onMounted } from "vue";
import { apiQuery } from "@/api/j24api";

const report = reactive([]);
const dateOfReport = ref("");
const loading = ref(true);
const searchValue = ref("");

const headers = [
  { text: "App Identifier", value: "cfbundleidentifier", sortable: true },
  { text: "App Path", value: "path", sortable: true },
  { text: "Architecture", value: "architecture", sortable: true },
  { text: "Installations", value: "_count", sortable: true },
];

async function getData() {
  const results = await apiQuery("ELA", "patching/patchusagereport", {
    appsToPatch: true,
  });

  console.log(results);
  report.length = 0;
  if (results.length) {
    report.push(...results[0].report);
    dateOfReport.value = results[0].date;
    // convert value of _count to number
    report.forEach((item) => {
      item._count = parseInt(item._count);
    });
  }
  loading.value = false;
}
onMounted(() => {
  console.log("Apps to patch");
  getData();
});
</script>

<template>
  <v-row class="pa-2">
    <v-col
      ><v-text-field
        label="Search..."
        v-model="searchValue"
        density="compact"
        hide-details
      ></v-text-field
    ></v-col>
  </v-row>
  <v-row class="px-2">
    <v-col cols="12">
      <EasyDataTable
        :headers="headers"
        :items="report"
        :search-field="['cfbundleidentifier', 'path']"
        :search-value="searchValue"
        :loading="loading"
      >
        <template #expand="item">
          <v-table>
            <thead>
              <tr>
                <th class="text-left">Customer</th>
                <th class="text-left">Count</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="breakdown in item.breakdown" :key="breakdown.customer">
                <td>{{ breakdown.company }}</td>
                <td>{{ breakdown._count }}</td>
              </tr>
            </tbody>
          </v-table>
        </template>
      </EasyDataTable>
    </v-col>
  </v-row>
</template>
